import { useContext } from 'react';
import { partition } from 'lodash';
import { constants } from '@clubmed/utils';
import { searchToBooking, bookmarkToBooking } from 'Components/utils/booking/bookingSearchUtils';
import { FavoriteProductListContext } from 'Context/FavoriteProductListContext';
const { TRAVELPLAN_TYPES } = constants;
export const useSearchBookings = () => {
  const {
    favoriteProductsState: { favoriteProductList },
    loading,
  } = useContext(FavoriteProductListContext);
  const [travelPlans, prebookings] = partition(
    favoriteProductList.filter((favorite) => !!favorite.reference),
    (favorite) => favorite.type === TRAVELPLAN_TYPES.TRAVELPLAN_TYPE_STANDARD,
  );
  const favorites = [
    ...travelPlans.map<BookingEntity>(searchToBooking),
    ...favoriteProductList
      .filter((favorite) => !favorite.reference)
      .map<BookingEntity>(bookmarkToBooking),
  ];
  return {
    prebookings: prebookings.map<BookingEntity>(searchToBooking),
    favorites,
    isLoading: loading,
  };
};
